/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchRunResultCompanySettlementsInner } from './BatchRunResultCompanySettlementsInner';
import {
    BatchRunResultCompanySettlementsInnerFromJSON,
    BatchRunResultCompanySettlementsInnerFromJSONTyped,
    BatchRunResultCompanySettlementsInnerToJSON,
    BatchRunResultCompanySettlementsInnerToJSONTyped,
} from './BatchRunResultCompanySettlementsInner';
import type { BatchRunResultPaymentGroupsInner } from './BatchRunResultPaymentGroupsInner';
import {
    BatchRunResultPaymentGroupsInnerFromJSON,
    BatchRunResultPaymentGroupsInnerFromJSONTyped,
    BatchRunResultPaymentGroupsInnerToJSON,
    BatchRunResultPaymentGroupsInnerToJSONTyped,
} from './BatchRunResultPaymentGroupsInner';
import type { ListBillings200ResponseDataInner } from './ListBillings200ResponseDataInner';
import {
    ListBillings200ResponseDataInnerFromJSON,
    ListBillings200ResponseDataInnerFromJSONTyped,
    ListBillings200ResponseDataInnerToJSON,
    ListBillings200ResponseDataInnerToJSONTyped,
} from './ListBillings200ResponseDataInner';
import type { BatchRunResultTotals } from './BatchRunResultTotals';
import {
    BatchRunResultTotalsFromJSON,
    BatchRunResultTotalsFromJSONTyped,
    BatchRunResultTotalsToJSON,
    BatchRunResultTotalsToJSONTyped,
} from './BatchRunResultTotals';
import type { BatchRunResultArtifacts } from './BatchRunResultArtifacts';
import {
    BatchRunResultArtifactsFromJSON,
    BatchRunResultArtifactsFromJSONTyped,
    BatchRunResultArtifactsToJSON,
    BatchRunResultArtifactsToJSONTyped,
} from './BatchRunResultArtifacts';
import type { BatchRunResultOperation } from './BatchRunResultOperation';
import {
    BatchRunResultOperationFromJSON,
    BatchRunResultOperationFromJSONTyped,
    BatchRunResultOperationToJSON,
    BatchRunResultOperationToJSONTyped,
} from './BatchRunResultOperation';
import type { BatchRunResultStatementSourceInner } from './BatchRunResultStatementSourceInner';
import {
    BatchRunResultStatementSourceInnerFromJSON,
    BatchRunResultStatementSourceInnerFromJSONTyped,
    BatchRunResultStatementSourceInnerToJSON,
    BatchRunResultStatementSourceInnerToJSONTyped,
} from './BatchRunResultStatementSourceInner';

/**
 * バッチ実行結果（batch service が成果物生成・アップロードに必要な情報を含む）。
 * 
 * @export
 * @interface BatchRunResult
 */
export interface BatchRunResult {
    /**
     * 
     * @type {BatchRunResultOperation}
     * @memberof BatchRunResult
     */
    operation: BatchRunResultOperation;
    /**
     * 
     * @type {BatchRunResultTotals}
     * @memberof BatchRunResult
     */
    totals: BatchRunResultTotals;
    /**
     * 
     * @type {Array<BatchRunResultPaymentGroupsInner>}
     * @memberof BatchRunResult
     */
    paymentGroups: Array<BatchRunResultPaymentGroupsInner>;
    /**
     * 会社単位の明細集計行
     * report CSVを生成する入力。
     * 
     * @type {Array<BatchRunResultCompanySettlementsInner>}
     * @memberof BatchRunResult
     */
    companySettlements?: Array<BatchRunResultCompanySettlementsInner>;
    /**
     * 注文明細一覧。
     * order_detail_report CSV は payment service 側で生成・S3 アップロード済みのため、
     * このフィールドは常に空配列を返す。
     * 
     * @type {Array<ListBillings200ResponseDataInner>}
     * @memberof BatchRunResult
     */
    orderDetails?: Array<ListBillings200ResponseDataInner>;
    /**
     * 
     * @type {BatchRunResultArtifacts}
     * @memberof BatchRunResult
     */
    artifacts: BatchRunResultArtifacts;
    /**
     * 会社精算書の生成に用いる元データ。
     * 
     * @type {Array<BatchRunResultStatementSourceInner>}
     * @memberof BatchRunResult
     */
    statementSource: Array<BatchRunResultStatementSourceInner>;
}

/**
 * Check if a given object implements the BatchRunResult interface.
 */
export function instanceOfBatchRunResult(value: object): value is BatchRunResult {
    if (!('operation' in value) || value['operation'] === undefined) return false;
    if (!('totals' in value) || value['totals'] === undefined) return false;
    if (!('paymentGroups' in value) || value['paymentGroups'] === undefined) return false;
    if (!('artifacts' in value) || value['artifacts'] === undefined) return false;
    if (!('statementSource' in value) || value['statementSource'] === undefined) return false;
    return true;
}

export function BatchRunResultFromJSON(json: any): BatchRunResult {
    return BatchRunResultFromJSONTyped(json, false);
}

export function BatchRunResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResult {
    if (json == null) {
        return json;
    }
    return {
        
        'operation': BatchRunResultOperationFromJSON(json['operation']),
        'totals': BatchRunResultTotalsFromJSON(json['totals']),
        'paymentGroups': ((json['payment_groups'] as Array<any>).map(BatchRunResultPaymentGroupsInnerFromJSON)),
        'companySettlements': json['company_settlements'] == null ? undefined : ((json['company_settlements'] as Array<any>).map(BatchRunResultCompanySettlementsInnerFromJSON)),
        'orderDetails': json['order_details'] == null ? undefined : ((json['order_details'] as Array<any>).map(ListBillings200ResponseDataInnerFromJSON)),
        'artifacts': BatchRunResultArtifactsFromJSON(json['artifacts']),
        'statementSource': ((json['statement_source'] as Array<any>).map(BatchRunResultStatementSourceInnerFromJSON)),
    };
}

export function BatchRunResultToJSON(json: any): BatchRunResult {
    return BatchRunResultToJSONTyped(json, false);
}

export function BatchRunResultToJSONTyped(value?: BatchRunResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation': BatchRunResultOperationToJSON(value['operation']),
        'totals': BatchRunResultTotalsToJSON(value['totals']),
        'payment_groups': ((value['paymentGroups'] as Array<any>).map(BatchRunResultPaymentGroupsInnerToJSON)),
        'company_settlements': value['companySettlements'] == null ? undefined : ((value['companySettlements'] as Array<any>).map(BatchRunResultCompanySettlementsInnerToJSON)),
        'order_details': value['orderDetails'] == null ? undefined : ((value['orderDetails'] as Array<any>).map(ListBillings200ResponseDataInnerToJSON)),
        'artifacts': BatchRunResultArtifactsToJSON(value['artifacts']),
        'statement_source': ((value['statementSource'] as Array<any>).map(BatchRunResultStatementSourceInnerToJSON)),
    };
}

